import React from 'react';
import Badge from '@widesk-ui/components/Badge';

export type BulletProps = {
	color?: string;
	style?: React.CSSProperties;
} & React.PropsWithChildren;

export default function Bullet(props: BulletProps) {
	return <Badge color={props.color ?? 'default'} text={<span style={props.style}>{props.children}</span>} />;
}
